import { v4 as uuidv4 } from "uuid";

function chillHop() {
  return [
    {
      name: "Dj Kurang Puas Viral ( teaster )",
      artist: "Vilky YT ft. Cantika Yt",
      audio: "https://f.top4top.io/m_3183oeeht0.mp3",
      cover: "https://b.top4top.io/p_31837o7ch0.png",
      id: uuidv4(),
      active: true,
      color: ["#60302E", "#CFC1B4"]
    },
    {
      name: "Dj Kalah Style JDM",
      artist: "VilkyYT",
      // audio: "https://cdn.pixabay.com/audio/2023/06/06/audio_cbcfcb18e6.mp3", // ! this is working fine
      audio: "https://raw.githubusercontent.com/Farhans4you/database/main/media/kalqhan.mp3", //--- Not working
      cover: "https://raw.githubusercontent.com/Farhans4you/database/main/media/Kalah.png",
      id: uuidv4(),
      active: true,
      color: ["#414141", "#BEBEBE"],
    },

    {
      name: "Dj Vilky Ganct",
      artist: "Farhans Fvndy",
      cover: "https://j.top4top.io/p_3183wt6nm0.jpg",
      id: uuidv4(),
      active: false,
      color: ["#414141", "#BEBEBE"],
      audio: "https://g.top4top.io/m_3183gitzv0.mp3",
    },

    {
      name: "I Wanna Be Yours",
      artist: "Arctic Monkeys",
      cover: "https://i.scdn.co/image/ab67616d00001e024ae1c4c5c45aabe565499163",
      id: uuidv4(),
      active: false,
      color: ["#414141", "#BEBEBE"],
      audio: "audio/12 Arctic Monkeys - I Wanna Be Yours.mp3",
    },
    {
      name: "Until I Found You",
      artist: "Stephen Sanchez",
      cover: "https://i.scdn.co/image/ab67616d00001e029522042f86d0bb0d4e9e3783",
      id: uuidv4(),
      active: false,
      color: ["#B7CDD8", "#D5B494"],
      audio: "audio/until i found you.m4a",
    },

    {
      name: "Double take",
      artist: "dhruv ",
      cover:
        " https://i.scdn.co/image/ab67616d00001e026f04e53cb5309f8e88286842",
      id: uuidv4(),
      active: false,
      color: ["#60302E", "#CFC1B4"],
      audio: "audio/double take.mp3",
    },
    {
      name: "Die For You",
      artist: " The Weeknd ",
      cover:
        " https://i.scdn.co/image/ab67616d00001e02a048415db06a5b6fa7ec4e1a",
      id: uuidv4(),
      active: false,
      color: ["#042469", "#A60127"],
      audio: "audio/Die For You   The Weeknd.mp3",
    },
    {
      name: "Rocket science",
      artist: " vaultboy music",
      cover:
        " https://i.scdn.co/image/ab67616d00001e02867e47321f5b1fd2339750f0",
      id: uuidv4(),
      active: false,
      color: ["#094C5D", "#0A4D5E"],
      audio: "audio/Rocket science - vaultboy music (official audio).mp3",
    },
    {
      name: "Eastside ",
      artist: " benny blanco, Halsey, Khalid",
      cover:
        " https://i.scdn.co/image/ab67616d00001e023154f0bdf9a17385d7afc6ba",
      id: uuidv4(),
      active: false,
      color: ["#E27499", "#F3F2F0"],
      audio: "audio/Eastside   benny blanco, Halsey, Khalid.mp3",
    },
  ];
}

export default chillHop;
